export default "__VITE_ASSET__CSyUn8AQ__"